import { action } from 'sky-engine/api/index'

import { OSTYPE_MNG, OS_TYPE_CONFIG_MNG } from '@/api/apiModules'
/**
 * 获取所有的操作系统
 * @returns
 */
export function getAllOsType() {
  const params = {
    exactMatchArr: [],
    matchArr: [],
    page: 0,
    limit: 1000
  }
  return action(OSTYPE_MNG, 'list', params)
}

/**
 * 获取所有的操作系统配置信息
 * @param {*} params
 * @returns
 */
export function getOsTypeConfig(params) {
  return action(OS_TYPE_CONFIG_MNG, 'list', params)
}
